import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { doc, getDoc, collection, query, orderBy, getDocs } from 'firebase/firestore';
import SEO from '../components/SEO';

import AnimatedSection from '../components/AnimatedSection';
import PageHeader from '../components/PageHeader';
import VisiMisi from '../components/VisiMisi';
import SambutanKepsek from '../components/SambutanKepsek';
import Sejarah from '../components/Sejarah';
import StrukturOrganisasi from '../components/StrukturOrganisasi';
import TenagaPendidik from '../components/TenagaPendidik';

const TentangKamiPage = () => {
  const [pageData, setPageData] = useState(null);
  const [staffList, setStaffList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAllData = async () => {
      setLoading(true);
      try {
        // Setup promises for concurrent fetching
        const pageContentPromise = getDoc(doc(db, 'pageContent', 'tentangKami'));
        const staffQuery = query(collection(db, 'staff'), orderBy('order', 'asc'));
        const staffPromise = getDocs(staffQuery);

        const [pageContentSnap, staffSnapshot] = await Promise.all([pageContentPromise, staffPromise]);

        // Process page content
        if (pageContentSnap.exists()) {
          setPageData(pageContentSnap.data());
        } else {
          console.log("No such document for 'Tentang Kami' page! Please create it in the admin panel.");
          setPageData({}); // Set to an empty object to avoid render errors
        }

        // Process staff list
        const staffData = staffSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setStaffList(staffData);

      } catch (error) {
        console.error("Error fetching 'Tentang Kami' data:", error);
        setPageData({}); // Also set to an empty object on error
      } finally {
        setLoading(false);
      }
    };

    fetchAllData();
  }, []);

  // Pisahkan staf menjadi tenaga pendidik dan kependidikan
  const pendidik = staffList.filter(s => s.type && s.type.startsWith('pendidik'));
  const kependidikan = staffList.filter(s => s.type === 'kependidikan');

  return (
    <>
      <SEO 
        title="Tentang Kami - SMK Pariwisata Sumbangsih" 
        description="Profil lengkap, sejarah, visi misi, serta struktur organisasi dan tenaga pengajar di SMK Pariwisata Sumbangsih." 
      />
      <PageHeader 
        title="Tentang Kami" 
        subtitle="Mengenal lebih dekat SMK Pariwisata Sumbangsih" 
      />
      {loading ? (
        <section className="section">
          <div className="container" style={{ textAlign: 'center' }}>Memuat konten...</div>
        </section>
      ) : (
        <>
          <AnimatedSection><SambutanKepsek content={pageData} /></AnimatedSection>
          <AnimatedSection><VisiMisi visi={pageData?.visi} misi={pageData?.misi} /></AnimatedSection>
          <AnimatedSection><Sejarah content={pageData} /></AnimatedSection>
          <AnimatedSection><StrukturOrganisasi content={pageData} /></AnimatedSection>
          <AnimatedSection>
            <TenagaPendidik pendidik={pendidik} kependidikan={kependidikan} loading={loading} />
          </AnimatedSection>
        </>
      )}
    </>
  );
};

export default TentangKamiPage;